import Cookies from 'js-cookie'
import { isNotEmpty } from './validate'
const TokenKey = 'Token'
const UserInfoKey = 'UserInfo'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getUser() {
  const item = Cookies.get(UserInfoKey)
  if (item != null) {
    return JSON.parse(item)
  } else {
    return null
  }
}
// 设置
export function setUser(userInfo, seconds) {
  if (isNotEmpty(seconds)) {
    return Cookies.set(UserInfoKey, JSON.stringify(userInfo), {
      expires: seconds / 86400
    })
  } else {
    return Cookies.set(UserInfoKey, JSON.stringify(userInfo))
  }
}
export function removeUser() {
  return Cookies.remove(UserInfoKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js